import { Grid, Typography } from '@mui/material';

import { SwitchController } from 'controllers/switch-controller';

import { planFeaturesFieldsStyles } from './styles';

const FEATURE_FIELDS = [
  { name: 'features.activityFeed', label: 'Activity Feed' },
  { name: 'features.schedule', label: 'Schedule' },
  { name: 'features.selections', label: 'Selections' },
  { name: 'features.fileCabinet', label: 'File Cabinet' },
  { name: 'features.finance', label: 'Finance' },
] as const;

export const PlanFeaturesFields = () => {
  return (
    <Grid sx={planFeaturesFieldsStyles.container}>
      <Typography sx={planFeaturesFieldsStyles.title}>Plan Features</Typography>
      <Grid sx={planFeaturesFieldsStyles.grid}>
        {FEATURE_FIELDS.map(({ name, label }) => (
          <Grid key={name} sx={planFeaturesFieldsStyles.row}>
            <SwitchController name={name} isSmall />
            <Typography sx={planFeaturesFieldsStyles.label}>{label}</Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
